import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCAWorkspaceStore } from '../modules/ca/state/caWorkspaceStore';
import {
  getActiveCAFirmRole,
  hasCAFirmAdminRole,
  type CAFirmRole,
} from '../utils/caRoleUtils';

export function useCAFirmAccess() {
  const { user, workspaceMode } = useAuth();
  const activeFirmId = useCAWorkspaceStore((state) => state.activeFirmId);

  return useMemo(() => {
    const isCAWorkspace = workspaceMode === 'ca';
    const role: CAFirmRole = isCAWorkspace ? getActiveCAFirmRole(user, activeFirmId) : 'viewer';
    const canManageFirm = isCAWorkspace && hasCAFirmAdminRole(role);

    return {
      isCAWorkspace,
      role,
      canManageFirm,
      canManageStaff: canManageFirm,
    };
  }, [workspaceMode, user, activeFirmId]);
}
